<template>
  <div v-for="user in users" :key="user.zupGuid" class="right-bar__time-count" :class="{'has-fv': holidaysCount > 0, 'has-error' : hasExcessFRV(user)}">
    <div class="right-bar-error" title="Необходимо скорректировать ФРВ сотрудника">
      <vita-icon name="warn-circle-red"/>
    </div>
    <div class="time-count__all">{{user.frv?.frvNorm ?? 0}} ч</div>
    <div class="time-count__actual">
      <span class="indicator" :class="[colorIndicator((user.frv?.frvNorm ?? NaN), (user.frv?.frvFact ?? NaN))]"></span>{{user.frv?.frvFact ?? 0}} ч <span class="time-count__proc">{{calculate((user.frv?.frvNorm ?? 0), (user.frv?.frvFact ?? 0))}} %</span></div>
    <div class="time-count__planned">
      <span class="indicator" :class="[colorIndicator((user.frv?.frvNorm ?? NaN), (user.frv?.frvSchedule ?? NaN))]"></span>{{formatNumber((user.frv?.frvSchedule ?? 0) +  (user.frv?.frvNew ?? 0))}} ч <span class="time-count__proc">{{calculate((user.frv?.frvNorm ?? 0), (user.frv?.frvSchedule ?? 0) + (user.frv?.frvNew ?? 0))}} %</span></div>
    <div class="time-count__all" v-if="holidaysCount > 0">
      <div>РВ: {{(user.frv?.frvFactRv ?? 0)}} ч / {{formatNumber(user.frv?.frvRvSchedule, user.frv?.frvRvNew)}} ч</div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {computed} from "vue";
import {NewUser} from "@/types";
import {useStore} from "vuex";

const store = useStore()

const users = computed<NewUser[]>(() => {
  return store.getters['data/pharmUsers']
})

const holidaysCount = computed<number>(() => {
  return store.getters['data/holidays'] && store.getters['data/holidays'].length
})

const calculate = (norm:number ,col:number): number => {
  if (norm) {
    const oneProc = norm / 100
    return +(col / oneProc).toFixed(1)
  } else {
    return 0
  }
}

const formatNumber = (planned = 0, actual = 0): string => {
  let str = (planned + actual).toFixed(2);

  if (str.includes('.')) {
    while (str.endsWith('0')) {
      str = str.slice(0, -1);
    }
    if (str.endsWith('.')) {
      str = str.slice(0, -1);
    }
  }

  return str;
}

const colorIndicator = (norm:number ,col: number): string => {
  if (norm === 0) {
    return 'grey'
  }

  if (col < norm) {
    return 'orange'
  } else if (col === norm) {
    return 'green'
  } else if (col > norm) {
    return 'red'
  } else {
    return 'grey'
  }
}

// Проверка на превышение выделенного ФРВ
const checkingNumbersVS = [2, 630, 24, 15, 6, 1221, 2051, 2092, 741]
const hasExcessFRV = (user: NewUser) => {
  if (!user.frv || !user.numberVs) return

  if ((user.frv.frvSchedule > user.frv.frvNorm) && checkingNumbersVS.includes(user.numberVs)) return true
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@use '../static/style/variables.scss' as *;
@use '../static/style/mixins.scss' as *;

.right-bar {
  max-width: 164px;
  min-width: 164px;
  margin-left: 12px;
  height: max-content;
  position: relative;

  &:last-child {
    border-radius: 3px;
    border-top: 1px solid #CCCCCC;
    border-left: 1px solid #CCCCCC;
    border-right: 1px solid #CCCCCC;
  }

  &__head {
    padding: 5px 6px;
    background: $bg-color-light;
    border-bottom: 1px solid #CCCCCC;
    border-radius: 3px;
    min-height: 64px;
  }

  &__sub-head {
    padding: 8px 6px;
    background: $bg-color-light;
    @include subtext;
    color: rgba(117, 117, 117, 1);
  }

  &__time-count {
    position: relative;
    background: $bg-color-light;
    height: 94px;
    padding: 18px 6px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    border-radius: 3px;
    color: #333333;
    margin-bottom: 6px;
    border: 1px solid #CCCCCC;
    font-size: 13px;
    font-weight: 500;
    gap: 6px;

    > div {
      line-height: 1.21;
    }

    &.has-fv {
      padding: 7px 6px;
    }

    &.has-error {
      border-color: #FF3B30;

      .right-bar-error {
        display: block;
      }
    }

    &:first-child {
      border-radius: 3px;
    }

    &:last-child {
      margin-bottom: 0;
    }

    .indicator {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: #DDDDDD;
      display: inline-block;
      margin-right: 4px;

      &.red {
        background: #E52E52;
      }

      &.orange {
        background: #FF6F20;
      }

      &.green {
        background: #30B648;
      }
    }
  }

  .time-count__all {
    padding-left: 12px;
  }

  .time-count__proc {
    color: #888;
    font-size: 12px;
  }

  .right-bar-info {
    position: absolute;
    top: 5px;
    right: 6px;
    cursor: pointer;
  }

  .right-bar-error {
    position: absolute;
    top: 5px;
    right: 6px;
    display: none;
  }
}
</style>
